import React, { useState } from "react";
import { Row, Col, Button } from "../../bootstrap/index.jsx";
import DropdownMenu, { Divider } from "../../common/Dropdown.jsx";
import update from "immutability-helper";

const FormValueOptions = ({
  indicatorValueOptions,
  qualitativeIndicatorValueOptions,
}) => {
  const [valueOptions, setValueOptions] = useState(
    indicatorValueOptions || qualitativeIndicatorValueOptions[0]
  );

  const updateValueOptionsDescription = (e) => {
    setValueOptions(
      update(valueOptions, {
        $merge: { description: e.target.value },
      })
    );
  };

  const valueOptionsChanged = (e, o) => {
    e.preventDefault();
    setValueOptions(o);
  };

  const updateValueOptionsOption = (idx, attr, value) => {
    setValueOptions(
      update(valueOptions, {
        options: {
          [idx]: {
            $merge: {
              [attr]: value,
            },
          },
        },
      })
    );
  };

  const deleteValueOptionsOption = (e, idx) => {
    e.preventDefault();
    setValueOptions(
      update(valueOptions, {
        options: { $splice: [[idx, 1]] },
      })
    );
  };

  const addValueOptionsOption = (e) => {
    e.preventDefault();
    setValueOptions(
      update(valueOptions, {
        options: { $push: [{}] },
      })
    );
  }

  let valueOptionOptions = [];

  qualitativeIndicatorValueOptions.forEach((o, i) => {
    if (i > 0) {
      valueOptionOptions.push(<Divider key={`${i}-div`} />);
    }

    valueOptionOptions.push(
      <li key={i}>
        <a href="#" onClick={(e) => valueOptionsChanged(e, o)}>
          <strong>{o.description}</strong>
          {o.options.map((o) => (
            <p key={o.value}>
              <span>{`${o.value}%`}</span>
              {o.label}
            </p>
          ))}
        </a>
      </li>
    );
  });

  return (
    <Row className="form-group value-options-fields">
      <label className="col-xs-12">
        {I18n.t("reporting_value")} *
        <div className="input-group">
          <input
            type="text"
            name="value_options[description]"
            className="form-control"
            value={valueOptions.description}
            placeholder={I18n.t(
              "qualitative_indicator_value_options_description_placeholder"
            )}
            onChange={updateValueOptionsDescription}
          />
          <div className="input-group-btn">
            <DropdownMenu
              label={<i className="fa fa-caret-down" />}
              classes="qualitative-indicator-value-options-selection"
            >
              {valueOptionOptions}
            </DropdownMenu>
          </div>
        </div>
      </label>
      <Col>
        {valueOptions.options.map((o, i) => (
          <Row key={i} className="option">
            <Col size="xs-3">
              <div className="input-group">
                <input
                  type="text"
                  name={`value_options[options[${i}]][value]`}
                  className="form-control"
                  value={o.value}
                  placeholder={I18n.t("value")}
                  onChange={(e) =>
                    updateValueOptionsOption(i, "value", e.target.value)
                  }
                />
                <div className="input-group-addon">%</div>
              </div>
            </Col>
            <Col size="xs-8">
              <input
                type="text"
                name={`value_options[options[${i}]][label]`}
                className="form-control"
                value={o.label}
                placeholder={I18n.t("description")}
                onChange={(e) =>
                  updateValueOptionsOption(i, "label", e.target.value)
                }
              />
            </Col>
            <Col size="xs-1">
              <Button
                type="danger"
                className="pull-right"
                onClick={(e) => deleteValueOptionsOption(e, i)}
              >
                <i className="icon icon-trash" />
              </Button>
            </Col>
          </Row>
        ))}
      </Col>
      <Col>
        <Button
          className="pull-right add-option"
          onClick={addValueOptionsOption}
        >
          <i className="icon icon-add" /> {I18n.t("add_option")}
        </Button>
      </Col>
    </Row>
  );
};

export default FormValueOptions;
